import { fetchHeaderFooterHomeData } from "../../lib/serverFetch";
import { getTermsOfUseDataAction } from "../../lib/actions/termsOfUseAction";
import PolicyPageClient from "../../components/policy/PolicyPageClient";

export const dynamic = "force-dynamic";

interface PageProps {
  searchParams: Promise<{ lang?: string; franchiseeId?: string }>;
}

export default async function TermsOfUsePage({ searchParams }: PageProps) {
  const { lang, franchiseeId } = await searchParams;

  const [headerFooterHomeData, response] = await Promise.all([
    fetchHeaderFooterHomeData(),
    getTermsOfUseDataAction(franchiseeId, lang),
  ]);

  const data =
    response.success && response.data
      ? { default: response.data.default, translated: response.data.translated }
      : { default: null, translated: null };

  return (
    <PolicyPageClient
      headerFooterHomeData={headerFooterHomeData}
      data={data}
      sectionKey="termsOfUse"
      fallbackHeading="Terms of Use"
    />
  );
}
